import { GetUserBrandPermission, GetUserShopPermission } from '@/api/priceSystem'

export function getUserBrandPermission() {
  GetUserBrandPermission().then(res => {
    if (res.data.res_status_code === '0' && res.data.res_content) {
      const brands = res.data.res_content.join(',')
      localStorage.setItem('brands', brands)
      return brands
    }
    return ''
  }).catch(err => {
    // 静默处理错误，避免404等错误导致页面循环刷新
    console.warn('[价格权限] 获取品牌权限失败:', err.message || err)
    return ''
  })
}

export function getUserShopPermission() {
  GetUserShopPermission().then(res => {
    if (res.data.res_status_code === '0' && res.data.res_content) {
      const shops = res.data.res_content.join(',')
      localStorage.setItem('shops', shops)
      return shops
    }
    return ''
  }).catch(err => {
    // 静默处理错误，避免404等错误导致页面循环刷新
    console.warn('[价格权限] 获取店铺权限失败:', err.message || err)
    return ''
  })
}
